﻿import mixin from './mixin';

import ActivitiesFilter from './components/ActivitiesFilter.vue';
import Activity from './components/Activity.vue';

const axios = require('axios');

const activitiesOverviewApp = {
	mixins: [mixin],
	components: { ActivitiesFilter, Activity },
	data() {
		return {
			dataApi: '',
			dataLimit: 8,
			dataGuid: '',
			dataLanguage: '',
			dataJson: null,

			loading: false,
			data: null,
			page: 0,
			initialLoad: true,

			filterSorts: [],
			filterCategories: [],
			filterRegions: [],
			filterDays: [],

			showModal: false,

			dataSortslabel: '',
			dataCategorieslabel: '',
			dataRegionslabel: '',
			dataDayslabel: '',

			dataSortinglabel: 'Sortering',
			dataStandardlabel: 'standaard',
			dataIncreasinglabel: 'titel (A-Z)',
			dataDecreasinglabel: 'titel (Z-A)',
			dataDateIncreasinglabel: 'datum (nieuwste)',
            dataDateDecreasinglabel: 'datum (oudste)',
			sorting: 'standaard',
		};
	},
	computed: {
		itemsSet() {
			return this.data && this.data.items && this.data.items.length;
		},
		offset() {
			return this.initialLoad ? 0 : this.dataLimit * this.page;
		},
		computedLimit() {
			return this.dataLimit + this.dataLimit * this.page;
		},
		queryParams() {
			const urlParams = new URLSearchParams();
			urlParams.set('parentNodeId', this.dataGuid);
			urlParams.set('cultureCode', this.dataLanguage);
			return urlParams.toString();
		},
		filteredItems() {
			if (!this.itemsSet) return [];
			let filteredItems = [...this.data.items];
			if (this.filterSorts.length) filteredItems = filteredItems.filter((item) => this.filterOnSort(item));
			if (this.filterCategories.length) filteredItems = filteredItems.filter((item) => this.filterOnCategory(item));
			if (this.filterRegions.length) filteredItems = filteredItems.filter((item) => this.filterOnRegion(item));
			if (this.filterDays.length) filteredItems = filteredItems.filter((item) => this.filterOnDay(item));
			
			return filteredItems;
		},
		limitedItems() {
			if (!this.itemsSet) return [];
			return this.filteredItems.slice(0, this.computedLimit);
		},
		sortedItems() {
			switch (this.sorting) {
				case this.dataStandardlabel:
					return this.limitedItems;
				case this.dataIncreasinglabel:
					return [...this.limitedItems].sort((a, b) => b.name.localeCompare(a.name));
				case this.dataDecreasinglabel:
					return [...this.limitedItems].sort((a, b) => a.name.localeCompare(b.name));
				case this.dataDateIncreasinglabel:
					return [...this.limitedItems].sort((a, b) => new Date(b.datum).getTime() - new Date(a.datum).getTime());
				case this.dataDateDecreasinglabel:
					return [...this.limitedItems].sort((a, b) => new Date(a.datum).getTime() - new Date(b.datum).getTime());
				default:
					return this.limitedItems;
			}
		},
		sorts() {
			if (!this.dataJson || !this.dataJson.Soorten || !this.itemsSet) return [];
			return this.dataJson.Soorten.filter(soort => {
				return this.data.items.some(item => item.soort.includes(soort.Naam)) ||
					soort.SubSoorten.some(subsoort => this.data.items.some(item => item.soort.includes(subsoort.Naam)))
			});
		},
		categories() {
			if (!this.dataJson || !this.dataJson.Categorieen || !this.itemsSet) return [];
			return this.dataJson.Categorieen.filter(categorie => {
				return this.data.items.some(item => item.categorie.includes(categorie.Naam)) ||
					categorie.SubCategorieen.some(subcat => this.data.items.some(item => item.categorie.includes(subcat.Naam)))
			});
		},
		regions() {
			if (!this.dataJson || !this.dataJson.Regios || !this.itemsSet) return [];
			return this.dataJson.Regios.filter(regio => this.data.items.some(item => item.regio.includes(regio.Naam)));
		},
		days() {
			if (!this.dataJson || !this.dataJson.Dagen || !this.itemsSet) return [];
			return this.dataJson.Dagen.filter(dag => this.data.items.some(item => item.dag.includes(dag.Naam)));
		},
		sortingOptions() {
			return [
				this.dataStandardlabel,
				this.dataDecreasinglabel,
				this.dataIncreasinglabel,
				this.dataDateIncreasinglabel,
				this.dataDateDecreasinglabel
			];
		},
	},
	methods: {
		async init() {
			this.loading = true;

			if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
			if (this.$el.dataset.guid) this.dataGuid = this.$el.dataset.guid;
			if (this.$el.dataset.language) this.dataLanguage = this.$el.dataset.language;
			if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
			if (this.$el.dataset.json) this.dataJson = JSON.parse(this.$el.dataset.json);

			if (this.$el.dataset.sortslabel) this.dataSortslabel = this.$el.dataset.sortslabel;
			if (this.$el.dataset.categorieslabel) this.dataCategorieslabel = this.$el.dataset.categorieslabel;
			if (this.$el.dataset.regionslabel) this.dataRegionslabel = this.$el.dataset.regionslabel;
			if (this.$el.dataset.dayslabel) this.dataDayslabel = this.$el.dataset.dayslabel;

			if (this.$el.dataset.sortinglabel) this.dataSortinglabel = this.$el.dataset.sortinglabel;
			if (this.$el.dataset.standardlabel) this.dataStandardlabel = this.$el.dataset.standardlabel;
			if (this.$el.dataset.increasinglabel) this.dataIncreasinglabel = this.$el.dataset.increasinglabel;
			if (this.$el.dataset.decreasinglabel) this.dataDecreasinglabel = this.$el.dataset.decreasinglabel;
			if (this.$el.dataset.dateincreasinglabel) this.dataDateIncreasinglabel = this.$el.dataset.dateincreasinglabel;
			if (this.$el.dataset.datedecreasinglabel) this.dataDateDecreasinglabel = this.$el.dataset.datedecreasinglabel;

			const response = await this.fetchData();
			if (response && response.data) this.data = response.data;
			this.loading = false;
		},
		async fetchData() {
			try {
				const response = await axios.get(`${this.dataApi}?${this.queryParams}`);
				return response;
			} catch (error) {
				console.log(error);
			}
		},
		loadMore() {
			this.page++;
			this.updateUrl();
		},
		updateUrl() {
			const urlParams = new URLSearchParams();
			this.page ? urlParams.append('page', this.page) : urlParams.delete('page');
			this.filterSorts.length ? urlParams.append('sorts', this.filterSorts.join('+')) : urlParams.delete('sorts');
			this.filterCategories.length ? urlParams.append('categories', this.filterCategories.join('+')) : urlParams.delete('categories');
			this.filterRegions.length ? urlParams.append('regions', this.filterRegions.join('+')) : urlParams.delete('regions');
			this.filterDays.length ? urlParams.append('days', this.filterDays.join('+')) : urlParams.delete('days');
			history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
		},
		filterOnSort(item) {
			return this.filterSorts.includes(item.soort);
		},
		filterOnCategory(item) {
			return this.filterCategories.includes(item.categorie);
		},
		filterOnRegion(item) {
			return this.filterRegions.includes(item.regio);
		},
		filterOnDay(item) {
			return item.dag.some(dag => this.filterDays.includes(dag));
        },
		onFilterSort(sortName) {
			const newFilterSorts = [...this.filterSorts];
			const index = newFilterSorts.indexOf(sortName);
			if (index > -1) {
				newFilterSorts.splice(index, 1);
				const topSort = this.sorts.find((s) => s.Naam === sortName);
				if (topSort) {
					topSort.SubSoorten.forEach((subSort) => {
						const subIndex = newFilterSorts.indexOf(subSort.Naam);
						if (subIndex > -1) {
							newFilterSorts.splice(subIndex, 1);
						}
					});
				}
			} else {
				newFilterSorts.push(sortName);
				const topSort = this.sorts.find((s) => s.Naam === sortName);
				if (topSort) {
					topSort.SubSoorten.forEach((subSort) => {
						if (!newFilterSorts.includes(subSort.Naam)) {
							newFilterSorts.push(subSort.Naam);
						}
					});
				}
			}
			this.filterSorts = newFilterSorts;
			this.page = 0;
			this.updateUrl();
		},
		onFilterCategory(categoryName) {
			const newFilterCategories = [...this.filterCategories];
			const index = newFilterCategories.indexOf(categoryName);
			if (index > -1) {
				newFilterCategories.splice(index, 1);
				const topCategory = this.categories.find((c) => c.Naam === categoryName);
				if (topCategory) {
					topCategory.SubCategorieen.forEach((subCategory) => {
						const subIndex = newFilterCategories.indexOf(subCategory.Naam);
						if (subIndex > -1) {
							newFilterCategories.splice(subIndex, 1);
						}
					});
				}
			} else {
				newFilterCategories.push(categoryName);
				const topCategory = this.categories.find((c) => c.Naam === categoryName);
				if (topCategory) {
					topCategory.SubCategorieen.forEach((subCategory) => {
						if (!newFilterCategories.includes(subCategory.Naam)) {
							newFilterCategories.push(subCategory.Naam);
						}
					});
				}
			}
			this.filterCategories = newFilterCategories;
			this.page = 0;
			this.updateUrl();
		},
		onFilterRegion(regionName) {
			const index = this.filterRegions.indexOf(regionName);
			if (index > -1) {
				this.filterRegions.splice(index, 1);
			} else {
				this.filterRegions.push(regionName);
			}
			this.page = 0;
			this.updateUrl();
		},
		onFilterDay(dayName) {
			const index = this.filterDays.indexOf(dayName);
			if (index > -1) {
				this.filterDays.splice(index, 1);
			} else {
				this.filterDays.push(dayName);
			}
			this.page = 0;
			this.updateUrl();
		},
		openModal() {
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		openDropdown(ref) {
			if (this.$refs[ref]) {
				this.$refs[ref].classList.add('is-active');

				document.addEventListener('click', (event) => {
					if (!this.$refs[ref].contains(event.target)) {
						this.$refs[ref].classList.remove('is-active');
					}
				});
			}
		},
		setSorting(sorting, ref) {
			if (this.$refs[ref]) {
				this.$refs[ref].classList.remove('is-active');
			}
			this.sorting = sorting;
			const url = new URL(location);
			url.searchParams.set('sorting', this.sorting);
			if (this.sorting === 'standaard') url.searchParams.delete('sorting');
			history.pushState({}, '', url);
		},
	},
	created() {
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has('page')) this.page = parseInt(urlParams.get('page'));
		if (urlParams.has('sorts')) this.filterSorts = urlParams.get('sorts').split('+');
		if (urlParams.has('categories')) this.filterCategories = urlParams.get('categories').split('+');
		if (urlParams.has('regions')) this.filterRegions = urlParams.get('regions').split('+');
		if (urlParams.has('days')) this.filterDays = urlParams.get('days').split('+');
		if (urlParams.has('sorting')) this.sorting = urlParams.get('sorting');
	},
	mounted() {
		this.init();
	},
};

export default activitiesOverviewApp;
